import { LegalPage } from "../../components/LegalPage";

export function Dpa() {
  return (
    <LegalPage
      title="Data Processing Agreement"
      description="WeConsult Rx Data Processing Agreement covering GDPR Article 28 obligations and Standard Contractual Clauses for international transfers."
      path="/dpa"
      effective="2026-05-30"
    >
      <p>
        Our Data Processing Agreement (“DPA”) supplements the Master Services
        Agreement and the Business Associate Agreement to address EU/UK General
        Data Protection Regulation (GDPR), the UK Data Protection Act, and
        applicable US state privacy laws.
      </p>

      <h2>Subject matter &amp; duration</h2>
      <p>
        WeConsult Rx processes personal data on behalf of the Customer for the
        duration of the Service term, plus the wind-down period defined in the
        MSA.
      </p>

      <h2>Roles</h2>
      <p>
        Customer is the Controller; WeConsult Rx is the Processor. Where
        WeConsult Rx engages subprocessors, those subprocessors are
        sub-processors of the Customer.
      </p>

      <h2>Categories of data subjects &amp; data</h2>
      <ul>
        <li>Customer staff (admins, reviewers).</li>
        <li>Facility staff (administrators, medical directors, providers).</li>
        <li>Residents / patients (PHI) — only as instructed by the Customer.</li>
        <li>End-user identifiers (name, email, phone), authentication metadata, and audit log entries.</li>
      </ul>

      <h2>Subprocessor list</h2>
      <p>
        See <a href="/subprocessors">/subprocessors</a> for the full list.
        Customers will be notified at least 30 days before a new subprocessor
        is engaged for any covered data category.
      </p>

      <h2>International transfers</h2>
      <p>
        We rely on the EU Standard Contractual Clauses (Commission Implementing
        Decision 2021/914) and the UK International Data Transfer Addendum
        where required.
      </p>

      <h2>Security measures</h2>
      <p>
        Technical and organisational measures are described in our{" "}
        <a href="/security">Security overview</a> and exhibited in the DPA
        Annex. We will not materially reduce these measures during the term.
      </p>

      <h2>Audit rights</h2>
      <p>
        Customer may request, no more than annually, an audit by an independent
        third party at Customer’s cost, subject to confidentiality and to a
        reasonable schedule.
      </p>

      <h2>Data subject requests</h2>
      <p>
        We will assist Customer in fulfilling data subject access, correction,
        deletion, restriction, and portability requests within applicable
        statutory deadlines.
      </p>

      <h2>Breach notification</h2>
      <p>
        We notify Customer of a Personal Data Breach without undue delay, and
        no later than 72 hours after we become aware where required by Article
        33(2) GDPR.
      </p>

      <h2>Signing the DPA</h2>
      <p>
        Request a countersigned DPA: email privacy@weconsultrx.com.
      </p>
    </LegalPage>
  );
}
